'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { switchMap } from 'rxjs/operators/switchMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { tap } from 'rxjs/operators/tap';
import ContentRoutes from 'ContentUtils/Routes';
import { CREATED_TRANSLATION_VARIATION } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { requestCreateTranslationVariation, requestedCreateTranslationVariationFailure, requestedCreateTranslationVariationSuccess } from '../actions/ContentActions';
import { ContentTypes } from '../constants/base';
export default ((action$, _, {
  BlogSettingsClient,
  ContentClient
}) => {
  const createTranslationVariation = ({
    contentGroupId,
    contentType,
    id,
    language,
    masterLanguage,
    name
  }) => {
    return ContentClient.createTranslationVariation(contentType, id, language, masterLanguage, name, contentGroupId).pipe(tap(({
      categoryId,
      id: cloneId
    }) => window.open(ContentRoutes.edit(cloneId, categoryId))), mergeMap(() => of(closeModal(), requestedCreateTranslationVariationSuccess(contentType))), catchError(error => of(requestedCreateTranslationVariationFailure(error, contentType))), startWith(requestCreateTranslationVariation()));
  };

  const createMlangBlogAndBlogPostVariation = ({
    contentGroupId,
    contentType,
    id,
    language,
    masterLanguage,
    name
  }) => {
    return BlogSettingsClient.createLanguageVariation({
      contentGroupId,
      language,
      masterLanguage
    }).pipe(switchMap(() => createTranslationVariation({
      contentGroupId,
      contentType,
      id,
      language,
      masterLanguage,
      name
    })), catchError(error => of(requestedCreateTranslationVariationFailure(error, contentType))));
  };

  return action$.ofType(CREATED_TRANSLATION_VARIATION).pipe(mergeMap(({
    payload: {
      contentGroupId,
      contentType,
      id,
      language,
      masterLanguage,
      name,
      shouldCreateNewBlogVariation
    }
  }) => {
    return contentType === ContentTypes.BLOG_POST && shouldCreateNewBlogVariation ? createMlangBlogAndBlogPostVariation({
      contentGroupId,
      contentType,
      id,
      language,
      masterLanguage,
      name
    }) : createTranslationVariation({
      contentGroupId,
      contentType,
      id,
      language,
      masterLanguage,
      name
    });
  }));
});